
/**
 * Safely renders HTML content by creating a trusted object for dangerouslySetInnerHTML
 */
export const renderHTML = (html: string | null | undefined) => {
  if (!html) return { __html: '' };
  return { __html: html };
};

/**
 * Formats a date string to a human readable format
 */
export const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

/**
 * Formats a number as a price in Indonesian Rupiah
 */
export const formatPrice = (amount: number) => {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};
